// Custom
export const EMAIL = {
  MAX_CHARACTERS: 254,
};

export const PASSWORD = {
  MAX_CHARACTERS: 254,
  MIN_CHARACTERS: 8,
};
